import './App.css';
import {
	BrowserRouter,
	Navigate,
	Outlet,
	Route,
	Routes,
} from 'react-router-dom';
import { getAccessToken } from './Utils/AuthUtil';
import Conversations from './pages/Conversations/Conversations';
import Login from './pages/Login';
import ChatHistoryList from './pages/ChatHistoryList';
import AgentRequests from './pages/AgentRequests';

function App() {
	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route element={<AuthenticationRoutes />}>
						<Route path="/" element={<Login />} />
					</Route>
					<Route element={<PrivateRoutes />}>
						<Route path="/chats" element={<Conversations />} />
						<Route
							path="/chatHistory"
							element={<ChatHistoryList />}
						/>
						<Route
							path="/agentRequest"
							element={<AgentRequests />}
						/>
					</Route>
				</Routes>
			</BrowserRouter>
		</>
	);
}

function PrivateRoutes() {
	return getAccessToken() ? <Outlet /> : <Navigate to="/" />;
}

function AuthenticationRoutes() {
	return getAccessToken() ? <Navigate to="/chats" /> : <Outlet />;
}

export default App;
